/**
 * PHYSICAL-RISK.FORMATTER.TS
 * Format risk object
 */
import { t } from "i18next"
import { getStatusLabelKey, PreventionAction, PreventionActionStatus } from "./prevention-action.types"
import type { PreventionActionContext } from "./prevention-action.store"

//Libelle commun aux cartes et a la fiche, avec les memes priorites de statut.
export function getPreventionActionStatusLabelFull(
  status: PreventionActionStatus,
  isOverdue = false,
  isToPlan = false
) {
  if (status === "done") return t(getStatusLabelKey(true))
  if (isOverdue) return "Mesure en retard"
  if (isToPlan) return "Mesure à planifier"
  return t(getStatusLabelKey(false))
}

/**
 * Formatter function
 */
export function formatPreventionAction(action: PreventionAction, context?: PreventionActionContext): PreventionAction {
  //Status
  let cStatus: PreventionActionStatus = "todo"
  if (action.dateDone) {
    cStatus = "done"
  } else if (action.dateStarted) {
    cStatus = "pending"
  }

  //Delay
  //Plus de 12 annoncer en années + mois si moins de 12 annoncer en mois uniquement
  let cRefreshDelayLabel: null | string = null
  if (action.refreshDelay) {
    const m = action.refreshDelay
    cRefreshDelayLabel = m % 12 === 0 ? (m === 12 ? "ans" : `${m / 12} ans`) : m === 1 ? "mois" : `${m} mois`
  }

  const risk = context?.physicalRisks.find((x) => x.id === action.PhysicalRiskId)
  const cRiskValueEffective = risk
    ? (risk.cValueEffective ?? (risk.frequency * risk.severity) / Math.max(1, risk.prevention))
    : null

  return {
    ...action,
    cStatus,
    cStatusLabel: t("prevention_action_status_" + cStatus),
    cRefreshDelayLabel,
    cRiskValueEffective
  }
}
